module.exports = __webpack_public_path__ + "media/images/pc/visit_reserve/kv-title-right-dda0ecaf914b2e69bf48cf3dff0ac855.png";